<template>

        <el-popover
            style="text-align: center"
            placement="left"
            title="工价明细"
            width="550"
            trigger="hover">
        <el-table :data="groupCraft.sizegroupcraftrecord_set">
            <el-table-column width="145" prop="shop_id" label="尺码"/>
            <el-table-column  prop="plan_num" label="通知数量"/>
            <el-table-column  prop="finish_num" label="上报数量"/>
            <el-table-column  prop="scrap_num" label="报次数量"/>
            <el-table-column  prop="price" label="单价"/>
            <el-table-column  prop="total" label="工价"/>
        </el-table>
            <el-tag size="mini" slot="reference"  type="primary">
            {{ totalMoney }}元
        </el-tag>
    </el-popover>


</template>

<script>
    export default {
        name: "CraftPriceClo",
        props:{
            groupCraft:Object,
        },
        computed:{
            totalMoney(){
                let total = 0
                this.groupCraft.sizegroupcraftrecord_set.forEach(sizeGroup=>{
                    total += sizeGroup.total
                })
                return total.toFixed(2)
            },
        },
    }
</script>

<style scoped>

</style>